module.exports = __webpack_public_path__ + "img/alien-egg.31803eff.svg";